import { combineReducers } from "redux";
import authReducer from "./authReducer";
import setupsettingReducer from "./setupsettingReducer";
import specialityReducer from './specialityReducer'
import { doctorListReducer } from './doctorReducers';
import socialMediaReducer from "./socialMediaReducer";
import { scheduleReducer } from "./scheduleReducer";
import prescriptionReducer from "./prescriptionReducer";
import likeDislikeReducer from "./likeDislikeReducer";
import {
  profileReducer,
  clinicImagesReducer,
  servicesReducer,
  specializationReducer,
  educationReducer,
  experienceReducer,
  awardsReducer,
  membershipsReducer,
  registrationsReducer,
  couponsReducer
} from './doctorReducers';
import { exerciseTemplateReducer } from "./exerciseTemplateReducer";
import exerciseAssignmentReducer from "./exerciseAssignmentReducer";
import patientProfileReducer from './patientProfileReducer';
import medicalRecordReducer from "./medicalRecordReducer";
import doctorProfileReducer from "./doctorProfileReducer";
import loginReducer from "./loginReducer";
import { updatedoctorProfileReducer } from "./doctorProfileUpdateReducer";
import booking from './bookingReducer';
import { appointmentReducer } from "./appointmentReducer";
import reviewReducer from "./reviewReducer";
import forgotPasswordReducer from "./forgotPasswordReducer";
import resetPasswordReducer from "./resetPasswordReducer";
import paymentReducer from "./paymentReducer";
import { invoiceReducer } from "./invoiceReducer";
import { upiDetailsReducer, bankDetailsReducer } from './bankDetailReducer';
import { payoutReducer, payoutStatusReducer } from "./payoutReducers";
import reportSettingsReducer from './reportSettingsReducer';
import favouritesReducer from './favouritesReducer';
import videoReducer from "./videoReducer";
import { doctorPayoutReducer } from './doctorPayoutReducer';
import smsReducer from "./smsReducer";
import { platformSettingsReducer } from './chargesSettingsReducer'; // Keep this import
import familyMembersReducer from './familyMembersReducer';
import { blogReducer } from "./blogReducer";
import AllOfferReducer from '../reducers/AllOffersReducer';
import blogMetricsReducer from "./blogMetricsReducer";
import businessAddonReducer from "./businessAddonReducer";
import businessModuleReducer from "./businessModuleReducer";
import AdminbusinessModelReducer from './adminBusinessModelReducer';
import addonPackageReducer from "./addonPackageReducer";
import discountReducer from "./discountReducer"
import { notificationReducer } from "./notificationReducer";
import paymentSettingReducer from "./paymentSettingReducer";
import videoSettingReducer from "./videoSettingReducer";
import reminderReducer from './reminderReducer'; 
import exerciseReducer from "./exerciseReducer";
import dietReducer from "./dietReducer";
import { transactionListAllReducer } from './transactionReducers';
import patientDietReducer from "./patientDietReducer";
import { dietTemplateReducer } from './dietTemplateReducer';
import currencyReducer from './currencyReducer';
import otpverifyReducer from './otpverifyReducer';
export default combineReducers({
  val: authReducer,
  authReducer,
  loginReducer: loginReducer,
  setupsettingReducer: setupsettingReducer,
  profile: profileReducer,
  clinicImages: clinicImagesReducer,
  services: servicesReducer,
  specializations: specializationReducer,
  education: educationReducer,
  experience: experienceReducer,
  awards: awardsReducer,
  memberships: membershipsReducer,
  registrations: registrationsReducer,
  speciality: specialityReducer,
  doctorList: doctorListReducer,
  specialities: specialityReducer,
  doctorProfile: doctorProfileReducer,
  updatedoctorProfile: updatedoctorProfileReducer,
  doctorFilter: doctorListReducer,
  booking,
  currencyReducer,
  socialMedia: socialMediaReducer,
  schedule: scheduleReducer,
  patientProfile: patientProfileReducer,
  appointment: appointmentReducer,
  patientList: patientProfileReducer,
  prescription: prescriptionReducer,
  medicalRecord: medicalRecordReducer,
  reviews: reviewReducer,
  likeDislike: likeDislikeReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  payment: paymentReducer,
  invoice: invoiceReducer,
  payout: payoutReducer,
  upiDetails: upiDetailsReducer,
  bankDetails: bankDetailsReducer,
  coupons: couponsReducer,
  reportSettings: reportSettingsReducer,
  favourites: favouritesReducer,
  payoutStatus: payoutStatusReducer,
  doctorPayout: doctorPayoutReducer,
  sms: smsReducer,
  video: videoReducer,
  platformSettingsReducer,
  platformSettings: platformSettingsReducer, // <--- Change this line
  familyMembers: familyMembersReducer,
  blogReducer,
  offer: AllOfferReducer,
  blogMetricsReducer,
  businessModule: businessModuleReducer,
  exercise: exerciseReducer, 
  businessModels: AdminbusinessModelReducer, // Corrected name for consistency with state access
  addonPackages: addonPackageReducer,   // Corrected name for consistency with state access
  businessAddons:businessAddonReducer,//for doctor selected addon
  discounts:discountReducer,
  notification: notificationReducer,
  paymentSetting:paymentSettingReducer,
  videoSetting: videoSettingReducer, // ADD THIS LINE
   reminderList: reminderReducer,
    diet: dietReducer,
     patientDiet: patientDietReducer,
   exerciseAssignment: exerciseAssignmentReducer,
     exerciseTemplates: exerciseTemplateReducer, 
     transactionListAll: transactionListAllReducer,
     dietTemplates: dietTemplateReducer, 
     otpverify:otpverifyReducer


});

